import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios);
import VueCookies from 'vue-cookies'
Vue.use(Router)
Vue.use(VueCookies);

export default new Router({
  routes: [{
    path: '/',
    component: () => import('./views/adminLogin.vue')
  },
  //admin登陆后有左菜单
  {
    path: '/admin',
    component: () => import('./views/adminTpl.vue'),
    beforeEnter: (to, from, next) => {
      axios
          .get("https://www.bioflin.com:83/admin/admin_is_login", {
          //.get("http://api.yelibio.cn/admin/admin_is_login", {
          //.get("http://lineapi.bioflin.com/admin/admin_is_login", {
          params: {
            username: VueCookies.get('username'),
            token: VueCookies.get('token'),
          }
        })
        .then(res => {
          if (res.data == 1) {
            next();
          } else {
            next('/');
          }
        });
    },

    children: [
      //采购模块路由
      {
        path: 'pur_wait',
        components: {
          default: () => import('./views/purchase/wait.vue'),
        },
      },
      {
        path: 'pur_advice',
        components: {
          default: () => import('./views/purchase/advice.vue'),
        },
      },
      //财务模块路由
      {
        path: 'f_confirm',
        components: {
          default: () => import('./views/financial/confirm.vue'),
        },
      },
      {
        path: 'f_confirm_pay',
        components: {
          default: () => import('./views/financial/confirm_pay.vue'),
        },
      },
      {
        path: 'f_payment',
        components: {
          default: () => import('./views/financial/payment.vue'),
        },
      },
      {
        path: 'f_return_money',
        components: {
          default: () => import('./views/financial/return_moeny.vue'),
        },
      },  
      {
        path: 'f_return_product',
        components: {
          default: () => import('./views/financial/return_product.vue'),
        },
      }, 
      {
        path: 'f_card_pay',
        components: {
          default: () => import('./views/financial/cardpay.vue'),
        },
      },   
      {
        path: 'f_apply_card',
        components: {
          default: () => import('./views/financial/applycard.vue'),
        },
      },  
      // 其他
      {
        path: 'c_service',
        components: {
          default: () => import('./views/service/service.vue'),
        },
      },
      {
        path: 'bioLookList',
        components: {
          default: () => import('./views/bio_Look/bioLookList.vue'),
        },
      },
      {
        path: 'looksupplierList',
        components: {
          default: () => import('./views/bio_Look/supplierList.vue'),
        },
      },
      {
        path: 'd_orderList',
        components: {
          default: () => import('./views/d_orderList.vue'),
        },
      },
      {
        path: 'wait_buy_order',
        components: {
          default: () => import('./views/order/wait_buy_order.vue'),
        },
      },
      {
        path: 'd_Shipment',
        components: {
          default: () => import('./views/d_Shipment.vue'),
        },
      },
      {
        path: 'd_orderDone',
        components: {
          default: () => import('./views/d_orderDone.vue'),
        },
      },
      {
        path: 'd_orderCall',
        components: {
          default: () => import('./views/d_orderCall.vue'),
        },
      },
      {
        path: 'd_advice',
        components: {
          default: () => import('./views/d_advice.vue'),
        },
      },
      {
        path: 'd_returns',
        components: {
          default: () => import('./views/d_returns.vue'),
        },
      },
      {
        path: 'd_refund',
        components: {
          default: () => import('./views/d_refund.vue'),
        },
      },
      {
        path: 'd_inventory',
        components: {
          default: () => import('./views/d_inventory.vue'),
        },
      },
      {
        path: 'd_orderPayment',
        components: {
          default: () => import('./views/d_orderPayment.vue'),
        },
      },
      {
        path: 'y_userList',
        components: {
          default: () => import('./views/y_userList.vue'),
        },
      },
      {
        path: 'y_brokerage',
        components: {
          default: () => import('./views/y_brokerage.vue'),
        },
      },
      {
        path: 'y_service',
        components: {
          default: () => import('./views/service/service.vue'),
        },
      },
      {
        path: 'chart/:fd',
        components: {
          default: () => import('./views/service/chart.vue'),
        },
      },
      {
        path: 'y_integral',
        components: {
          default: () => import('./views/y_integral.vue'),
        },
      },
      {
        path: 'y_itgRule',
        components: {
          default: () => import('./views/y_itgRule.vue'),
        },
      },
      {
        path: 'y_audit',
        components: {
          default: () => import('./views/y_audit.vue'),
        },
      },
      {
        path: 'y_exchange',
        components: {
          default: () => import('./views/y_exchange.vue'),
        },
      },
      {
        path: 'g_adCommodity',
        components: {
          default: () => import('./views/g_adCommodity.vue'),
        },
      },
      {
        path: 'y_duty',
        components: {
          default: () => import('./views/y_duty.vue'),
        },
      },
      {
        path: 'y_main',
        components: {
          default: () => import('./views/y_main.vue'),
        },
      },
      {
        path: 'y_payments_user',
        components: {
          default: () => import('./views/y_payments_user.vue'),
        },
      },
      {
        path: 'c_share_product',
        components: {
          default: () => import('./views/c_shareProduct.vue'),
        },
      },
      {
        path: 'c_seckill',
        components: {
          default: () => import('./views/c_seckill.vue'),
        },
      },
      {
        path: 'c_seckillTime',
        components: {
          default: () => import('./views/c_seckillTime.vue'),
        },
      },
      {
        path: 'c_integral',
        components: {
          default: () => import('./views/c_integral.vue'),
        },
      },
      {
        path: 'c_special',
        components: {
          default: () => import('./views/c_special.vue'),
        },
      },
      {
        path: 'c_preference',
        components: {
          default: () => import('./views/c_preference.vue'),
        },
      },
      {
        path: 'c_popularity',
        components: {
          default: () => import('./views/c_popularity.vue'),
        },
      },
      {
        path: 'c_items',
        components: {
          default: () => import('./views/c_items.vue'),
        },
      },
      {
        path: 'c_classified',
        components: {
          default: () => import('./views/c_classified.vue'),
        },
      },
      {
        path: 'lookGood',
        components: {
          default: () => import('./views/lookGood.vue'),
        },
      },

      {
        path: 'c_classComp/:id',
        components: {
          default: () => import('./views/c_classComp.vue'),
        },
      },
      {
        path: 'g_Setting',
        components: {
          default: () => import('./views/g_Setting.vue'),
        },
      },
      {
        path: 'g_logistics',
        components: {
          default: () => import('./views/g_logistics.vue'),
        },
      },
      {
        path: 'g_setPay',
        components: {
          default: () => import('./views/g_setPay.vue'),
        },
      },
      {
        path: 'g_advertising',
        components: {
          default: () => import('./views/g_advertising.vue'),
        },
      },
      {
        path: 'g_advertising1',
        components: {
          default: () => import('./views/g_advertising1.vue'),
        },
      },
      {
        path: 'g_addAdvering/:id',
        components: {
          default: () => import('./views/g_addAdvering.vue'),
        },
      },
      {
        path: 'g_issue',
        components: {
          default: () => import('./views/g_issue.vue'),
        },
      },
      {
        path: 'g_notice',
        components: {
          default: () => import('./views/g_notice.vue'),
        },
      },
      {
        path: 'g_notices',
        components: {
          default: () => import('./views/g_notices.vue'),
        },
      },
      {
        path: 'g_reci',
        components: {
          default: () => import('./views/g_reci.vue'),
        },
      },
      {
        path: 'g_adminProtocol',
        components: {
          default: () => import('./views/g_adminProtocol.vue'),
        },
      },
      {
        path: 'permission', //权限---管理员列表
        components: {
          default: () => import('./views/permission.vue'),
        },
      },
      {
        path: 'groupList', //权限---部门管理列表
        components: {
          default: () => import('./views/groupList.vue'),
        },
      },
      {
        path: 'adminLog', //权限--操作日志
        components: {
          default: () => import('./views/adminLog.vue'),
        },
      },
      {
        path: 'admin_index',
        components: {
          default: () => import('./views/admin_index.vue'),
        },
      },
      {
        path: 'admin_account',
        components: {
          default: () => import('./views/admin_account.vue'),
        },
      },
      {
        path: 'admin_journal',
        components: {
          default: () => import('./views/admin_journal.vue'),
        },
      },
      {
        path: 'admin_system',
        components: {
          default: () => import('./views/admin_system.vue'),
        },
      },
      {
        path: 'admin_serve',
        components: {
          default: () => import('./views/admin_serve.vue'),
        },
      },
      {
        path: 'admin_activity',
        components: {
          default: () => import('./views/admin_activity.vue'),
        },
      },

      //////配置各路由的子路由

      {
        path: 'y_userLook/:id/:s', //权限--操作日志
        components: {
          default: () => import('./views/y_userLook.vue'),
        },

      },
      {
        path: 'd_viewOrde/:id/:s',
        components: {
          default: () => import('./views/d_viewOrde.vue'),
        },
      },
      {
        path: 'd_finance',
        components: {
          default: () => import('./views/d_finance.vue'),
        },
      },
      {
        path: 'd_orderTail/:id',
        components: {
          default: () => import('./views/d_orderTail.vue'),
        },
      },
      {
        path: 'd_returnDetail/:id',
        components: {
          default: () => import('./views/d_returnDetail.vue'),
        },
      },
      {
        path: 'd_refundDetail/:id',
        components: {
          default: () => import('./views/d_refundDetail.vue'),
        },
      },
      {
        path: 'y_integralSudary/:id',
        components: {
          default: () => import('./views/y_integralSudary.vue'),
        },
      },
      {
        path: 'y_auditLook/:id',
        components: {
          default: () => import('./views/y_auditLook.vue'),
        },
      },
      {
        path: 'y_exchangeLook/:id',
        components: {
          default: () => import('./views/y_exchangeLook.vue'),
        },
      },
      {
        path: 'y_mainLook/:id',
        components: {
          default: () => import('./views/y_mainLook.vue'),
        },
      },
      {
        path: 'c_seckillTime_list/:id',
        components: {
          default: () => import('./views/c_seckillTime_list.vue'),
        },

      },
      {
        path: 'c_seckillAdd/:id',
        components: {
          default: () => import('./views/c_seckillAdd.vue'),
        },
      },
      {
        path: 'c_integralAdd',
        components: {
          default: () => import('./views/c_integralAdd.vue'),
        },
      },
      {
        path: 'c_addSpecial',
        components: {
          default: () => import('./views/c_addSpecial.vue'),
        },
      },
      {
        path: 'c_specialLook/:id',
        components: {
          default: () => import('./views/c_specialLook.vue'),
        },
      },

      {
        path: 'c_additem',
        components: {
          default: () => import('./views/c_additem.vue'),
        },
      },
      {
        path: 'c_addPref',
        components: {
          default: () => import('./views/c_addPref.vue'),
        },
      },
      {
        path: 'c_addPoputy',
        components: {
          default: () => import('./views/c_addPoputy.vue'),
        },
      },
      {
        path: 'add_admin',
        components: {
          default: () => import('./views/add_admin.vue'),
        },
      },
      {
        path: 'redactPmision/:id',
        components: {
          default: () => import('./views/redactPmision.vue'),
        },
      },
      {
        path: 'adminstrList',
        components: {
          default: () => import('./views/adminstrList.vue'),
        },
      },
      {
        path: 'management/:id',
        components: {
          default: () => import('./views/permissions/check_permissions.vue'),
        },
      },
      {
        path: 'g_redactPay/:id',
        components: {
          default: () => import('./views/g_redactPay.vue'),
        },
      },
      {
        path: 'g_addAdvering1/:id',
        components: {
          default: () => import('./views/g_addAdvering1.vue'),
        },
      },
      {
        path: 'g_note',
        components: {
          default: () => import('./views/g_note.vue'),
        },
      },
      {
        path: 'g_issueSet/:id',
        components: {
          default: () => import('./views/g_issueSet.vue'),
        },
      },
      {
        path: 'g_addArticle',
        components: {
          default: () => import('./views/g_addArticle.vue'),
        },
      },
      {
        path: 'g_redArticle/:id',
        components: {
          default: () => import('./views/g_redArticle.vue'),
        },
      },
      {
        path: 'OrderRate',
        components: {
          default: () => import('./views/OrderRate.vue'),
        },
      },
      {
        path: 'rateLook/:id',
        components: {
          default: () => import('./views/rateLook.vue'),
        },
      },
      {
        path: 'c_groupList',
        components: {
          default: () => import('./views/c_groupList.vue'),
        },
      },
      {
        path: 'c_addgroup',
        components: {
          default: () => import('./views/c_addgroup.vue'),
        },
      },
      {
        path: 'y_feedback',
        components: {
          default: () => import('./views/y_feedback.vue'),
        },
      },
      {
        path: 'y_shopfeedback',
        components: {
          default: () => import('./views/y_shopfeedback.vue'),
        },
      },
      //商品
      {
        path: 'brand', //品牌管理
        name: "admin.brand.brand",
        components: {

          default: () => import('./views/Brand.vue'),
        },
      },
      {
        path: 'add_brand', //添加新品牌
        name: "admin.product.brand",
        components: {
          default: () => import('./views/addBrand.vue'),
        },
      },
      {
        path: 'edit_brand/:id', //编辑品牌
        name: "admin.product.edit_brand",
        components: {
          default: () => import('./views/editBrand.vue'),
        },
      },
      {
        path: 'list', //商品分类列表
        name: "admin.product.list",
        components: {
          default: () => import('./views/productList.vue'),
        },
      },
      {
        path: 'add1', //选择商品分类
        name: "admin.product.add1",
        components: {
          default: () => import('./views/Add1.vue'),
        },
      },
      {
        path: 'add2', //选择商品分类
        name: "admin.product.add1.add2",
        components: {
          default: () => import('./views/Add2.vue'),
        },
      },
      {
        path: 'gallery', //图片库
        name: "admin.product.gallery",
        components: {
          default: () => import('./views/Gallery.vue'),
        },
      },
      {
        path: 'view_gallery/:id', //图片列表
        name: "admin.product.gallery.viewGallery",
        components: {
          default: () => import('./views/viewGallery.vue'),
        },
      },
      {
        path: 'create_gallery', //新建相册
        name: "admin.product.gallery.createGallery",
        components: {
          default: () => import('./views/createGallery.vue'),
        },
      },
      {
        path: 'edit_gallery/:id',
        name: "admin.product.gallery.editGallery",
        components: {
          default: () => import('./views/editGallery.vue'),
        },
      },
      {
        path: 'addSupplier',
        name: "admin.product.supplier.addSupplier",
        components: {
          default: () => import('./views/supplier/addSupplier.vue'),
        },
      },
      {
        path: 'supplierEdit/:id',
        name: "admin.product.supplier.supplierEdit",
        components: {
          default: () => import('./views/supplier/supplierEdit.vue'),
        },
      },
      {
        path: 'supplierList',
        name: "admin.product.supplier.supplierList",
        components: {
          default: () => import('./views/supplier/supplierList.vue'),
        },
      },
      {
        path: 'supplierDetail/:id',
        name: "admin.product.supplier.supplierDetail",
        components: {
          default: () => import('./views/supplier/supplierDetail.vue'),
        },
      },
      {
        path: 'edit_category', //商品分类
        name: "admin.product.edit_category",
        components: {
          default: () => import('./views/editCategory.vue'),
        },
      },
      {
        path: 'comd_compile/:id',
        name: "admin.product.comd_compile",
        components: {
          default: () => import('./views/comd_compile.vue'),
        },
      },
      {
        path: 'inventoryList',
        name: "admin.product.supplier.inventoryList",
        components: {
          default: () => import('./views/inventory/inventoryList.vue'),
        },
      },
      {
        path: 'inventoryLog/:id',
        name: "admin.product.supplier.inventoryLog",
        components: {
          default: () => import('./views/inventory/inventoryLog.vue'),
        },
      },
      {
        path: 'inventoryLog2',
        name: "admin.product.supplier.inventoryLog2",
        components: {
          default: () => import('./views/inventory/inventoryLog2.vue'),
        },
      },
      {
        path: 'inventoryLog3',
        name: "admin.product.supplier.inventoryLog3",
        components: {
          default: () => import('./views/inventory/inventoryLog3.vue'),
        },
      },
      {
        path: 'clientList',
        name: "admin.product.sell.clientList",
        components: {
          default: () => import('./views/sell/clientList.vue'),
        },
      },
      {
        path: 'allocationClient/:id',
        name: "admin.product.sell.allocationClient",
        components: {
          default: () => import('./views/sell/allocationClient.vue'),
        },
      },
      {
        path: 'callIn',
        name: "admin.product.sell.callIn",
        components: {
          default: () => import('./views/sell/callIn.vue'),
        },
      },
      {
        path: 'sell_orderList',
        name: "admin.product.sell.sell_orderList",
        components: {
          default: () => import('./views/sell/sell_orderList.vue'),
        },
      },
      {
        path: 'shoplist',
        components: {
          default: () => import('./views/shop/shopList.vue'),
        },
      },
      {
        path: 'shoplook/:id',
        components: {
          default: () => import('./views/shop/shopLook.vue'),
        },
      },
      {
        path: 'shoplookorder/:id',
        components: {
          default: () => import('./views/shop/shopLookOrder.vue'),
        },
      },
      {
        path: 'applylist',
        components: {
          default: () => import('./views/shop/applyList.vue'),
        },
      },
      {
        path: 'shoplists',
        components: {
          default: () => import('./views/shop/shopLists.vue'),
        },
      },
      {
        path: 'shopproduct',
        components: {
          default: () => import('./views/shop/productList.vue'),
        },
      },
      {
        path: 'applyProduct',
        components: {
          default: () => import('./views/shop/applyProduct.vue'),
        },
      },
      {
        path: 'shopOrderList',
        components: {
          default: () => import('./views/shop/shopOrderList.vue'),
        },
      },
      {
        path: 'shopOrderAccount',
        components: {
          default: () => import('./views/shop/shopOrderAccount.vue'),
        },
      },
      {
        path: 'applyLog',
        components: {
          default: () => import('./views/shop/applyLog.vue'),
        },
      },
      
    ]
  },
  ]
})
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}